<section class="connection-toast" fxFlex fxLayout="row" fxLayoutAlign="center center" [@slideDownUpAnimation]="{value: animationState}" (@slideDownUpAnimation.done)="onSlideAnimationFinished($event)">
  <mat-icon class="connectivity-toast-icon" svgIcon="hourglass"></mat-icon>
  <p class="b1 hint" fxLayoutAlign="center center">{{ 'GENERAL.PLEASE_WAIT' | bmsTranslate }}</p>
</section>
